module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/024-004c1b1b7330009e4ce8e8e81f4402ff.jpg";